const dateFormat = new Intl.DateTimeFormat('ru-RU', {
	day: 'numeric',
	month: 'long',
	year: 'numeric',
	hour: '2-digit',
	minute: '2-digit',
	timeZone: 'Europe/Moscow',
});

export const formatCommentDate = (date: Date | string | number) => dateFormat.format(new Date(date));
